<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">STOCK DE ACEITE</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        inputs:[
            {tipo:'select',valor:'',label:'Turno*',key:'turnos_id',opciones:[],texto:'nombre_turno',seleccion:'id'},
            {tipo:'fecha',valor:'',label:'Fecha*',key:'fecha',picker:false,index:0},
            {tipo:'select',valor:'',label:'Estanque*',key:'estanque_aceites_id',opciones:[],texto:'nombre',seleccion:'id'},
            {tipo:'numero',valor:'0',label:'Stock Bins*',key:'stock_bins'},
            {tipo:'numero',valor:'0',label:'Producido*',key:'producido'},
            {tipo:'numero',valor:'0',label:'Despachado*',key:'despachado'},
            {tipo:'numero',valor:'0',label:'Saldo*',key:'saldo'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Turno',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'turno.nombre_turno'
                },
                {
                    text: 'Fecha',
                    align: 'center',
                    sortable: true,
                    value: 'fecha',
                },
                {
                    text: 'Estanque',
                    align: 'center',
                    sortable: true,
                    value: 'estanque_aceites.nombre',
                },
                {
                    text: 'Bins',
                    align: 'center',
                    sortable: true,
                    value: 'stock_bins',
                },
                {
                    text: 'Producido',
                    align: 'center',
                    sortable: true,
                    value: 'producido',
                },
                {
                    text: 'Despachado',
                    align: 'center',
                    sortable: true,
                    value: 'despachado',
                },
                {
                    text: 'Saldo',
                    align: 'center',
                    sortable: true,
                    value: 'saldo',
                },
                
                { text: 'Acciones', value: 'action', sortable: false, align:'center' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    mounted() {
        this.cargarTurnos();
        this.cargarEstanques();
        this.cargarDatos();
    },
    methods: {
        async cargarTurnos(){
            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log(this.inputs);
                this.inputs[0].opciones = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarEstanques(){
            let url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log(this.inputs);
                this.inputs[2].opciones = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}stock_aceites`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Registrar Aceite';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'stock_aceites';
            this.configuracion_modal.tipo_peticion = 'POST';
            Event.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Stock';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `stock_aceites/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            Event.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table
    }
}
</script>